
import { baseApi } from "@store/apis";
import localStorageSecureWrapper from "@utilities/localStorageSecureWrapper";

import type { ApiResponse } from "../models";
import type { HistoryRequest, HistoryResponse } from "./models";


const GetHistoryQuery = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GetHistory: builder.query({
      query: ({ page, itemsPerPage, searchQuery }: HistoryRequest) => ({
        url: "GetChallengeHistoryForUser",
        params: {
          Page: page,
          ItemsPerPage: itemsPerPage,
          SearchQuery: searchQuery,
          UserId: localStorageSecureWrapper.getItem("userId"),
        },
        method: "GET",
      }),
      transformResponse: (response: ApiResponse<HistoryResponse>) =>
        response.result,
    }),
  }),
});
export const { useLazyGetHistoryQuery } = GetHistoryQuery;
